var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowLeft, ArrowRight, ArrowUp, ArrowDown, } from "./component/InternalIcons";
export var FunctionKeyAttributeName = {
    controlKey: "controlKey",
    altKey: "altKey",
    shiftKey: "shiftKey",
    deleteKey: "deleteKey",
    escapeKey: "escapeKey",
    tabKey: "tabKey",
    homeKey: "homeKey",
    endKey: "endKey",
    leftArrowKey: "leftArrowKey",
    rightArrowKey: "rightArrowKey",
    upArrowKey: "upArrowKey",
    downArrowKey: "downArrowKey",
    enterKey: "enterKey",
    f1Key: "f1Key",
    f2Key: "f2Key",
    f3Key: "f3Key",
    f4Key: "f4Key",
    f5Key: "f5Key",
    f6Key: "f6Key",
    f7Key: "f7Key",
    f8Key: "f8Key",
    f9Key: "f9Key",
    f10Key: "f10Key",
    f11Key: "f11Key",
    f12Key: "f12Key",
};
export var FunctionKeyId = {
    controlKey: "_fn_key_Ctrl",
    altKey: "_fn_key_Alt",
    shiftKey: "_fn_key_Shift",
    deleteKey: "_fn_key_Del",
    escapeKey: "_fn_key_Esc",
    tabKey: "_fn_key_Tab",
    homeKey: "_fn_key_Home",
    endKey: "_fn_key_End",
    leftArrowKey: "_fn_key_left_arrow",
    rightArrowKey: "_fn_key_right_arrow",
    upArrowKey: "_fn_key_up_arrow",
    downArrowKey: "_fn_key_down_arrow",
    enterKey: "_fn_key_Enter",
    f1Key: "_fn_key_F1",
    f2Key: "_fn_key_F2",
    f3Key: "_fn_key_F3",
    f4Key: "_fn_key_F4",
    f5Key: "_fn_key_F5",
    f6Key: "_fn_key_F6",
    f7Key: "_fn_key_F7",
    f8Key: "_fn_key_F8",
    f9Key: "_fn_key_F9",
    f10Key: "_fn_key_F10",
    f11Key: "_fn_key_F11",
    f12Key: "_fn_key_F12",
};
export var DefaultComposableKeyLabel = (_a = {},
    _a[FunctionKeyAttributeName.controlKey] = "Ctrl",
    _a[FunctionKeyAttributeName.altKey] = "Alt",
    _a[FunctionKeyAttributeName.shiftKey] = "Shift",
    _a);
export var PreDefaultFunctionKeys = [
    {
        label: "Del",
        name: FunctionKeyAttributeName.deleteKey,
        id: FunctionKeyId.deleteKey,
    },
    {
        label: "Esc",
        name: FunctionKeyAttributeName.escapeKey,
        id: FunctionKeyId.escapeKey,
    },
    {
        label: "Tab",
        name: FunctionKeyAttributeName.tabKey,
        id: FunctionKeyId.tabKey,
    },
];
export var PostDefaultFunctionKeys = [
    {
        label: "Home",
        name: FunctionKeyAttributeName.homeKey,
        id: FunctionKeyId.homeKey,
    },
    {
        label: "End",
        name: FunctionKeyAttributeName.endKey,
        id: FunctionKeyId.endKey,
    },
    {
        label: _jsx(ArrowLeft, {}),
        name: FunctionKeyAttributeName.leftArrowKey,
        id: FunctionKeyId.leftArrowKey,
    },
    {
        label: _jsx(ArrowRight, {}),
        name: FunctionKeyAttributeName.rightArrowKey,
        id: FunctionKeyId.rightArrowKey,
    },
    {
        label: _jsx(ArrowUp, {}),
        name: FunctionKeyAttributeName.upArrowKey,
        id: FunctionKeyId.upArrowKey,
    },
    {
        label: _jsx(ArrowDown, {}),
        name: FunctionKeyAttributeName.downArrowKey,
        id: FunctionKeyId.downArrowKey,
    },
    {
        label: "Enter",
        name: FunctionKeyAttributeName.enterKey,
        id: FunctionKeyId.enterKey,
    },
    {
        label: "F1",
        name: FunctionKeyAttributeName.f1Key,
        id: FunctionKeyId.f1Key,
    },
    {
        label: "F2",
        name: FunctionKeyAttributeName.f2Key,
        id: FunctionKeyId.f2Key,
    },
    {
        label: "F3",
        name: FunctionKeyAttributeName.f3Key,
        id: FunctionKeyId.f3Key,
    },
    {
        label: "F4",
        name: FunctionKeyAttributeName.f4Key,
        id: FunctionKeyId.f4Key,
    },
    {
        label: "F5",
        name: FunctionKeyAttributeName.f5Key,
        id: FunctionKeyId.f5Key,
    },
    {
        label: "F6",
        name: FunctionKeyAttributeName.f6Key,
        id: FunctionKeyId.f6Key,
    },
    {
        label: "F7",
        name: FunctionKeyAttributeName.f7Key,
        id: FunctionKeyId.f7Key,
    },
    {
        label: "F8",
        name: FunctionKeyAttributeName.f8Key,
        id: FunctionKeyId.f8Key,
    },
    {
        label: "F9",
        name: FunctionKeyAttributeName.f9Key,
        id: FunctionKeyId.f9Key,
    },
    {
        label: "F10",
        name: FunctionKeyAttributeName.f10Key,
        id: FunctionKeyId.f10Key,
    },
    {
        label: "F11",
        name: FunctionKeyAttributeName.f11Key,
        id: FunctionKeyId.f11Key,
    },
    {
        label: "F12",
        name: FunctionKeyAttributeName.f12Key,
        id: FunctionKeyId.f12Key,
    },
];
